var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.18182V5.12581M16 2.18182V5.12581M20.5909 8.89202H3.09091M3.01465 13.2464H20.9351M3.08833 17.5323H20.9119M15.0049 21.8182L15.0049 8.89202M9.00977 21.8182L9.00977 8.89202M16 3.65381C19.33 3.83045 21 5.07674 21 9.68898V15.7536C21 19.7967 20 21.8182 15 21.8182H9C4 21.8182 3 19.7967 3 15.7536V9.68898C3 5.07674 4.67 3.84027 8 3.65381H16Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCal2);
export default __webpack_public_path__ + "static/media/cal2.555f23356b27b1f7bf89ede4b04908dc.svg";
export { ForwardRef as ReactComponent };